/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsForgotPasswordConfirm204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsForgotPasswordConfirm505Schema = z.any();

export const optionsForgotPasswordConfirmMutationResponseSchema = z.lazy(() => optionsForgotPasswordConfirm204Schema);
